import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import InputRange from "../InputRange";
import { withTranslation } from "../translation";
import {
  changeRangeFacet,
  applyRangeFacet,
  getStateForPriceSlider
} from "../../state/modules/search";
import styles from "./index.css";

const PriceSlider = ({ facet, formatCurrency, formatTranslation }) => {
  const dispatch = useDispatch();
  const priceRange = useSelector(getStateForPriceSlider);
  const { minValue, maxValue, step, value } = priceRange;

  const handleChangeComplete = () => dispatch(applyRangeFacet(facet));

  return (
    <InputRange
      maxAriaLabel={formatTranslation("plp_web_a11y_maximum_price")}
      minAriaLabel={formatTranslation("plp_web_a11y_minimum_price")}
      minValue={Math.max(0, minValue)}
      maxValue={Math.max(1, maxValue)}
      step={step}
      value={{
        min: Math.max(0, value.min),
        max: Math.max(1, value.max)
      }}
      formatLabel={val => formatCurrency(val, true)}
      onChange={val => {
        dispatch(
          changeRangeFacet(facet.id, {
            leftIndicator: val.min,
            rightIndicator: val.max
          })
        );
      }}
      onChangeComplete={handleChangeComplete}
      classNames={styles}
    />
  );
};

PriceSlider.propTypes = {
  facet: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  formatCurrency: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired
};

PriceSlider.displayName = "PriceSlider";

export default withTranslation(PriceSlider);
